import { type DirectEmbedStrategySettings } from '../../settings'

export const standard = {
  layout: {
    modes: {
      default: {
        targets: {
          overlay: {
            grid: {
              area: [['left', 'right']],
              columns: '1fr 1fr',
              rows: '1fr',
              gap: '5%'
            }
          }
        },
        fallbackPosition: 'right'
      },
      mobile: {
        targets: {
          overlay: { disabled: true }
        },
        details: {
          blockStyle: {
            paddingBottom: '16px'
          },
          target: { mode: 'fullscreen' }
        }
      },
      desktop: {
        details: {
          target: {
            mode: 'in-place'
          }
        }
      }
    },
    breakpoints: {
      order: ['mobile', 'desktop'],
      modes: {
        mobile: {
          mediaQuery: '(max-width: 600px)'
        },
        desktop: true
      }
    }
  }
} satisfies DirectEmbedStrategySettings

export const showcase = {
  layout: {
    modes: {
      default: standard.layout.modes.default,
      mobile: standard.layout.modes.mobile,
      mobileLg: {
        targets: {
          overlay: { disabled: true }
        },
        details: {
          target: {
            mode: 'bottom',
            targetStyle: {
              height: '33%'
            }
          }
        }
      },
      tablet: {
        details: {
          target: { mode: 'overlay', showPlayerControl: false }
        }
      },
      desktopSm: {
        details: {
          target: {
            mode: 'in-place'
          }
        }
      },
      desktop: standard.layout.modes.desktop
    },
    breakpoints: {
      order: ['mobile', 'mobileLg', 'tablet', 'desktopSm', 'desktop'],
      modes: {
        mobile: {
          mediaQuery: '(max-width: 600px)'
        },
        mobileLg: {
          mediaQuery: '(max-width: 800px)'
        },
        tablet: {
          mediaQuery: '(max-width: 1000px)'
        },
        desktopSm: {
          mediaQuery: '(max-width: 1400px)'
        },
        desktop: {
          maxMediaWidth: -1
        }
      }
    }
  }
} satisfies DirectEmbedStrategySettings

export const quads = {
  layout: {
    modes: {
      default: {
        targets: {
          overlay: {
            grid: {
              area: [['top-left', 'top-right'], ['bottom-left', 'bottom-right']],
              columns: '1fr 1fr',
              rows: '1fr',
              gap: '5%'
            },
            areas: {
              'bottom-left': {
                style: {
                  display: 'flex',
                  'flex-direction': 'column-reverse',
                  height: '100%'
                }
              },
              'bottom-right': {
                style: {
                  display: 'flex',
                  'flex-direction': 'column-reverse',
                  height: '100%'
                }
              }
            }
          }
        },
        fallbackPosition: 'top-right'
      },
      mobile: {
        targets: {
          overlay: { disabled: true }
        },
        details: {
          blockStyle: {
            paddingBottom: '16px'
          },
          target: { mode: 'fullscreen' }
        }
      },
      desktop: {
        details: {
          target: {
            mode: 'in-place'
          }
        }
      }
    },
    breakpoints: {
      order: ['mobile', 'desktop'],
      modes: {
        mobile: {
          mediaQuery: '(max-width: 600px)'
        },
        desktop: true
      }
    }
  }
} satisfies DirectEmbedStrategySettings
